<script setup lang="ts">
type Props = {
  modelValue: string[] | boolean;
  label: string;
  value: string;
  lightTheme?: boolean;
};

const props = defineProps<Props>();

const emit = defineEmits(['update:modelValue']);

const model = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
});
</script>

<template>
  <div :class="$style.checkboxWrapper">
    <input
      :id="`checkbox-${value}`"
      v-bind="$attrs"
      v-model="model"
      :class="[$style.checkboxInput, 'peer']"
      type="checkbox"
      :value="value"
    />
    <label
      :class="[
        $style.checkboxLabel,
        'group',
        lightTheme ? 'text-black/80' : 'text-texts',
      ]"
      :for="`checkbox-${value}`"
    >
      <span
        class=""
        :class="
          lightTheme
            ? 'bg-black/20 group-[.peer:checked+&]:bg-primary group-[.peer:disabled+&]:bg-black/60 group-[.peer:disabled+&]:cursor-not-allowed'
            : 'bg-white/20 group-[.peer:checked+&]:bg-success group-[.peer:disabled+&]:bg-white/10 group-[.peer:disabled+&]:cursor-not-allowed'
        "
      >
        <svg
          class="group-[.peer:checked+&]:fill-white"
          viewBox="0 0 16 16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.207 4.793a1 1 0 010
          1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5
          9.086l4.293-4.293a1 1 0 011.414 0z"
          />
        </svg>
      </span>
      <p
        :class="$style.checkboxParagraph"
        v-html="label"
      />
    </label>
  </div>
</template>

<style module lang="scss">
.checkboxWrapper {
  @apply flex items-center cursor-pointer;
}
.checkboxInput {
  @apply h-0 w-0 invisible;
}
.checkboxLabel {
  @apply flex items-center gap-3 text-sm font-medium cursor-pointer;

  .checkboxParagraph {
    @apply select-none text-xs leading-5;
  }

  span {
    @apply flex items-center justify-center rounded select-none;

    svg {
      @apply w-6 h-6 fill-white/5;
    }
  }
}
</style>
